import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductDetailService {

  private _reloadSubject = new Subject<void>();

  constructor() { }

  get reload$(): Observable<void> {
    return this._reloadSubject.asObservable();
  }

  reload() {
    this._reloadSubject.next();
  }
}